import lodash from 'lodash';
import * as notify from 'src/services/notification.service';

/**
 * @summary This method is used to get fields inside arrays of objects.
 * First it fetches array for the array path provided,
 * Then it gets its corresponding object and gets its field value in turn using fieldPath
 * @param companyprofile main company profile object
 * @param arrayPath this is the path to the array in which the field exists
 * @param fieldPath this is the path within that object of array, where field exists
 * @returns fields, which is an array of strings e.g. ['IT', 'IT', 'IT]
 */
export const getFieldsFromArray = (companyprofile: any, arrayPath: string, fieldPath: string) => {
  try {
    const fields: string[] = [];
    if (!companyprofile || !Object.keys(companyprofile).length) {
      throw new Error('Missing or invalid company profile object to get fields from array');
    }
    if (!arrayPath || !fieldPath) {
      throw new Error('Missing array path or field path');
    }
    // get the array from array level path
    const arr = lodash.get(companyprofile, arrayPath);
    // search the field inside the array of objects
    arr.forEach((object: any) => {
      const field = lodash.get(object, fieldPath);
      if (field) {
        fields.push(field);
      }
    });
    return fields;
  } catch (error: any) {
    console.log(error && error?.message);
    notify.error(error && error?.message);
  }
};
